import { useQuery } from "react-query"
import { queryKeys } from "../../client"
import api from "../../api"

const getData = async () => {
  const { data } = await api.get(`/task-tags`)
  return data.data
}

export const useTaskTags = () => {
  const { data, ...props } = useQuery(
    queryKeys.TASK_TAGS,
    () => getData(),
  )
  return { data, ...props }
}
